import React from "react";
import { TopBar } from "./components/TopBar";
import { Hero } from "./components/Hero";
import { Problem } from "./components/Problem";
import { Transformation } from "./components/Transformation";
import { Benefits } from "./components/Benefits";
import { Breakdown } from "./components/Breakdown";
import { Preview } from "./components/Preview";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Testimonials } from "./components/Testimonials";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { MobileCtaBar } from "./components/MobileCtaBar";
type AppProps = {
  showTestimonials?: boolean;
};
export function App({
  showTestimonials = true
}: AppProps) {
  return <div className="min-h-screen w-full overflow-x-clip bg-cream font-sans text-ink" data-id="element-0" data-mp="28te4dhn1dhp7">
      <TopBar data-id="element-1" data-mp="23w4ey1znd61d" />
      <Hero data-id="element-2" data-mp="23ujjma5idj2g" />
      <main data-id="element-3" data-mp="23ut97wmn5o7m">
        <Problem data-id="element-4" data-mp="23t8iki3g6pf1" />
        <Transformation data-id="element-5" data-mp="3ijxqiu0iq6lh" />
        <Benefits data-id="element-6" data-mp="3ikr002qv3a7b" />
        <Breakdown data-id="element-7" data-mp="3ij64oawq3n8e" />
        <Preview data-id="element-8" data-mp="3ijpc2xoqyt86" />
        <Bonuses data-id="element-9" data-mp="3ii4s22026sok" />
        <Offer data-id="element-10" data-mp="3mlavz2zp87rv" />
        {showTestimonials && <Testimonials data-id="element-11" data-mp="3mk85uxa7a9d0" />}
        <Faq data-id="element-12" data-mp="3mjpyb4i388ps" />
        <FinalCta data-id="element-13" data-mp="3mj6jvxrnc2gi" />
      </main>
      <Footer data-id="element-14" data-mp="3rbrc4uuwm7hx" />
      <MobileCtaBar data-id="element-15" data-mp="3rdas0kcnegj6" />
    </div>;
}